import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chatbot-header p-4 bg-gradient-to-r from-blue-800 to-blue-700 border-b border-blue-900 shadow-md" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-xl font-bold text-white mr-2" }
const _hoisted_6 = { class: "text-xs text-blue-100" }
const _hoisted_7 = { class: "font-medium text-white/90" }
const _hoisted_8 = { class: "text-white/80" }
const _hoisted_9 = { class: "flex items-center space-x-2" }
const _hoisted_10 = { class: "px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-white text-xs font-medium border border-white/30" }
const _hoisted_11 = { class: "text-sm text-blue-100 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.chatbotName), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userName || 'User'), 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mx-1 text-blue-300/80" }, "•", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatBusinessRole(_ctx.businessRole)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-history'))),
            class: "p-2 bg-white/20 backdrop-blur-sm rounded-full text-white hover:bg-white/30 transition-colors border border-white/30 flex items-center justify-center",
            "aria-label": "Chat history",
            title: "View chat history"
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              })
            ], -1)
          ])),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatChatbotEnv(_ctx.environment)), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.chatbotDescription), 1)
    ])
  ]))
}